import React from "react";

/** Reserved-height inline error slot so fields stay aligned when errors appear. */
const FieldError = ({ message, className = "" }) => (
  <p
    className={`mt-4 min-h-[20px] text-[14px] font-medium leading-5 text-orange-600 dark:text-orange-600 ${className}`}
    role={message ? "alert" : undefined}
  >
    {message || "\u00a0"}
  </p>
);

export default FieldError;
